'use client';

import { FormEvent, useState } from 'react';

import classNames from '@/shared/lib/classNames';
import { inputColor } from '@/shared/lib/constants';
import { parsePostLayout } from '@/shared/lib/posts';
import { BasicDropzone } from '@/shared/ui/upload-images';

import { usePosts } from '../model';

import PreviewPost from './PreviewPost';

import './style.css';

// FIXME: ReactQuill is temporarily disabled due to React 19 findDOMNode removal.
// Replace with a compatible rich text editor or re-enable when upstream is fixed.

export default function CreatePost() {
  const {
    cretePost,
    html,
    setHtml,
    setMetaTitle,
    setMetaDescription,
    pictureOwnerAttr,
    setPictureOwnerAttr
  } = usePosts();
  const [file, setFile] = useState<(File & { preview: string }) | null>(null);
  const [content, setContent] = useState<string | undefined>();
  const [openCreate, setOpen] = useState(false);
  const [charCount, setCharCount] = useState<number>(0);
  const [charDescrCount, setCharDescrCount] = useState<number>(0);

  const onPreview = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setContent(parsePostLayout(html));
  };

  const getFileUrl = (file: File & { preview: string }) => {
    setFile(file);
  };

  const createPostHandle = async () => {
    if (file) {
      cretePost(file);
    }
  };

  const handleInputTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputText = e.target.value;
    setCharCount(inputText.length);
    setMetaTitle(inputText);
  };

  const handleInputDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputText = e.target.value;
    setCharDescrCount(inputText.length);
    setMetaDescription(inputText);
  };

  const handleInputPictureOwnerAttrChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputText = e.target.value;
    setPictureOwnerAttr(inputText);
  };

  return (
    <>
      <div className="flex w-full justify-end">
        <button
          onClick={() => setOpen(!openCreate)}
          className="w-fit transform rounded-sm bg-yellow-300 px-4 py-3 transition-transform active:scale-95 dark:bg-yellow-600"
        >
          {openCreate ? 'Закрыть' : 'Открыть'}
        </button>
      </div>
      <div className={classNames(openCreate ? 'visible' : 'hidden', 'mb-36 flex h-full flex-col')}>
        <BasicDropzone getFile={getFileUrl} />
        <p className="font-bold"></p>
        <form onSubmit={onPreview} className="mb-12 flex flex-1 flex-col">
          {/* FIXME: Rich text editor stub. ReactQuill disabled for React 19. */}
          <textarea
            className="min-h-[200px] w-full rounded-md border-2 border-gray-300 p-3 dark:border-gray-600 dark:bg-slate-200 dark:text-black"
            value={html}
            onChange={(e) => setHtml(e.target.value)}
            placeholder="Введите текст поста..."
          />
          <section className="w-full">
            <label
              htmlFor="meta-title"
              className="mb-1 block font-medium text-gray-900 dark:text-white"
            >
              {'Мета <title> *'}
            </label>
            <div className={'inline-flex w-full gap-4'}>
              <input
                id="meta-title"
                className={`border-gray-300 dark:border-gray-600 ${inputColor} w-full rounded-md border-2 px-4 py-1.5`}
                onChange={handleInputTitleChange}
              />
            </div>
            <div>
              <p className="text-sm text-gray-500 dark:text-gray-400">{charCount}/64</p>
            </div>

            <label
              htmlFor="meta-description"
              className="mb-1 block font-medium text-gray-900 dark:text-white"
            >
              {'Мета <description> *'}
            </label>
            <div className={'inline-flex w-full gap-4'}>
              <input
                id="meta-description"
                className={`border-gray-300 dark:border-gray-600 ${inputColor} w-full rounded-md border-2 px-4 py-1.5`}
                onChange={handleInputDescriptionChange}
              />
            </div>
            <div>
              <p className="text-sm text-gray-500 dark:text-gray-400">{charDescrCount}/155</p>
            </div>
            <label
              htmlFor="cover-picture-owner-attribute"
              className="mb-1 block font-medium text-gray-900 dark:text-white"
            >
              {'Автор картинки'}
            </label>
            <div className={'inline-flex w-full gap-4'}>
              <input
                id="cover-picture-owner-attribute"
                className={`border-gray-300 dark:border-gray-600 ${inputColor} w-full rounded-md border-2 px-4 py-1.5`}
                onChange={handleInputPictureOwnerAttrChange}
              />
            </div>
          </section>
          <div className="flex justify-between pt-8">
            <button
              className="w-fit transform rounded-sm bg-yellow-300 px-4 py-3 transition-transform active:scale-95 dark:bg-yellow-600"
              type="submit"
            >
              Предпросмотр
            </button>
            <button
              className="w-fit transform rounded-sm bg-emerald-400 px-4 py-3 transition-transform active:scale-95 dark:bg-emerald-700"
              onClick={createPostHandle}
            >
              Сохранить
            </button>
          </div>
        </form>
        <PreviewPost
          coverPictureOwnerAttribute={pictureOwnerAttr}
          content={content ?? ''}
          file={file}
        />
      </div>
    </>
  );
}
